module.exports = __webpack_public_path__ + "media/volvo-penta.2d1ba3c7.mp4";